<template>
  <el-main class="container">
    <div class="title">房源信息</div>
    <div class="row">
      <div class="item">
        <div class="star">房源名称</div>
        <el-input placeholder="请输入房源名称" class="input" v-model="body.name"></el-input>
      </div>
      <div class="item">
        <div class="star">排列序号</div>
        <el-input placeholder="请输入排列序号" class="input" v-model="body.indexNum" type="number"></el-input>
      </div>
      <div class="item">
        <div class="star">联系电话</div>
        <el-input placeholder="请输入联系电话" class="input" v-model="body.linkPhone"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <div>租赁价格</div>
        <el-input placeholder="请输入价格或区间价格" class="input" v-model="body.leasePrice"></el-input>
      </div>
      <div class="item">
        <div class="star">建筑面积</div>
        <el-input placeholder="例：598m2" class="input" v-model="body.coveredArea"></el-input>
      </div>
      <div class="item">
        <div>交付标准</div>
        <el-input placeholder="请输入交付标准" class="input" v-model="body.windowFaces"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <div>户型介绍</div>
        <el-input placeholder="请输入户型介绍" class="input" v-model="body.apartmentIntroduction"></el-input>
      </div>
      <div class="item">
        <div class="star">所属精选项目</div>
        <el-select class="select" v-model="selectProject" clearable>
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="img-box">
      <div class="cover-item">
        <div class="img-title">封面图（{{coverNum}}/1）</div>
        <UpLoadImg
          tips="(255*169)"
          :img="banners"
          :length='1'
          :size="[350, 180]"
          @get-files="getbanner"/>
      </div>
      <div class="carousel-item">
        <div class="img-title">轮播图（{{carouselNum}}/6）</div>
        <UpLoadImg
          tips="(686*264)"
          :img="carouselBanners"
          :length='6'
          :size="[350, 180]"
          @get-files="getCarousel"/>
      </div>
    </div>
    <div class="video-box">
      <div class="name">视频（{{videoNum}}/1）</div>
      <video v-if="videoFlag" :src="videoUrl" class="video" controls="controls">您的浏览器不支持视频播放</video>
      <el-upload
        class="upload-video"
        :data="data"
        :action="uploadVideoUrl"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-error="handleError"
        :on-remove="handleRemove"
        :show-file-list="false"
        :on-exceed="handleExceed"
        :on-progress="uploadVideoProcess"
      >
        <el-progress v-if="!videoFlag" type="circle" :percentage="videoUploadPercent" style="margin:30px 0;"></el-progress>
        <el-button type="primary" icon="el-icon-upload2" :loading="uploadLoading">上传文件</el-button>
      </el-upload>
      <el-button class="remove-video" type="danger" v-if="videoFlag" @click="removeViedo">移除视频</el-button>
    </div>
    <div class="rich-text-box">
      <div>户型格局</div>
      <wang-editor
        class="rich-text"
        ref="editor"
        @editorContent="getEditorContent"/>
    </div>

    <div class="btn-box">
      <el-button @click="handleBack">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-main>
</template>

<script>
import UpLoadImg from '@/components/upload-img'
import WangEditor from '@/components/Wangeditor/index'
import env from '@/configs/env'
import getQiniuToken from '@/api/common'
import {
  addHouse,
  getAllProject,
  houseDetail,
  updateHouse
} from '@/api/featured'
export default {
  data() {
    return {
      videoNum: 0,
      coverNum: 0,
      carouselNum: 0,
      body: {
        apartmentIntroduction: '',
        coveredArea: '',
        indexNum: '',
        introduction: '',
        leasePrice: '',
        linkPhone: '',
        name: '',
        picture: '',
        pictureList: [],
        projectUuid: '',
        video: '',
        windowFaces: ''
      },
      projectList: [],
      selectProject: '',
      carouselBanners: [],
      banners: [],
      uploadVideoUrl: env.qnUploadImgDomain,
      videoUrl: '',
      uploadLoading: false,
      videoFlag: false,
      pageType: 'add',
      videoUploadPercent: 0,
      data: {
        token: ''
      },
      uuid: ''
    }
  },
  async created() {
    await this.network().getAllProject()
    if(this.$route.params.id){
      this.pageType = 'set'
      await this.network().houseDetail(this.$route.params.id)
    }
  },
  methods: {
    network() {
      return {
        addHouse: async() => {
          await addHouse(this.body)
          this.$message.success('新增成功')
          this.$router.push('/house-list')
        },
        getAllProject: async() => {
          const { data } = await getAllProject()
          this.projectList = []
          data.forEach(item => {
            this.projectList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        houseDetail: async(uuid)=>{
          let { data } = await houseDetail(uuid)
          for(let key in this.body){
            let val = data[key]
            if(data[key]){
              this.body[key] = val
            }
          }
          this.carouselBanners = []
          this.banners = []
          this.selectProject = ''

          this.banners.push(data.picture)
          data.pictureList.forEach(item=>{
            this.carouselBanners.push(item)
          })
          this.selectProject = data.projectUuid
          this.coverNum = this.banners.length
          this.carouselNum = this.carouselBanners.length
          data.video ? this.videoUrl = `${env.qnImgDomain}${data.video}` : this.videoUrl = ''
          data.video ? this.videoNum = 1 : this.videoNum = 0;
          data.video ? this.videoFlag = true : this.videoFlag = false;
          this.$refs.editor.setHtml(this.body.introduction)
          this.uuid = data.uuid
        },
        updateHouse: async()=>{
          let data = {
            ...this.body,
            uuid: this.uuid
          }
          await updateHouse(data)
          this.$message.success('修改成功')
          this.$router.push('/house-list')
        }
      }
    },
    // 获取编辑器内容
    getEditorContent(data) {
      let html = '<p><br></p>'
      if(data === html){
        this.body.introduction = ''
      } else {
        this.body.introduction = data
      }
    },
    getbanner(file, files) {
      if (files.length > 0) {
        this.body.picture = files[0].response
        this.coverNum = 1
      } else {
        this.coverNum = 0
      }
    },
    getCarousel(file, files) {
      if (files.length > 0) {
        const res = []
        files.forEach(item => {
          if (item.response === undefined) {
            let url = 'https://cdn.gymoo.cn/'
            let _res = item.url.replace(url, '')
            res.push(_res)
          } else {
            res.push(item.response)
          }
        })
        this.body.pictureList = res
        this.carouselNum = this.body.pictureList.length
      } else {
        this.carouselNum = 0
      }
    },
    async beforeUpload(file) {
      if (file.type.indexOf('video') === -1) {
        this.$notify({
          title: '警告',
          message: `请上传视频文件！`,
          type: 'warning'
        })
        return false
      }
      const { data } = await getQiniuToken()
      this.data.token = data.token
      this.uploadLoading = true
      this.videoFlag = false
      this.videoNum = 0
      this.videoUploadPercent = 0
      return true
    },
    handleSuccess(res, file, fileList) {
      this.body.video = ''
      this.videoUrl = ''
      this.$message.success('上传成功')
      this.body.video = file.response.hash
      this.videoUrl = `${env.qnImgDomain}${file.response.hash}`
      this.videoFlag = true
      this.videoNum = 1
      this.uploadLoading = false
    },
    handleRemove(file, fileList) {
      this.$message.success('文件移除成功')
      this.body.video = ''
      this.videoNum = 0
    },
    handleExceed() {
      this.$notify({
        title: '警告',
        message: `只能上传1个视频文件`,
        type: 'warning'
      })
    },
    handleError(){

    },
    uploadVideoProcess(event, file, fileList) {
      this.videoUploadPercent = parseInt(file.percentage.toFixed(0))
    },
    checkForm() {
      if (this.body.name === '') {
        this.$message.error('请输入房源名称')
        return false
      } else if (this.body.indexNum === '') {
        this.$message.error('请输入排列序号')
        return false
      } else if (this.body.linkPhone === '') {
        this.$message.error('请输入联系电话')
        return false
      }
      //  else if (this.body.leasePrice === '') {
      //   this.$message.error('请输入租赁价格')
      //   return false
      // } 
      else if (this.body.coveredArea === '') {
        this.$message.error('请输入建筑面积')
        return false
      } 
      // else if (this.body.windowFaces === '') {
      //   this.$message.error('请输入交付标准')
      //   return false
      // } 
      // else if (this.body.apartmentIntroduction === '') {
      //   this.$message.error('请输入户型介绍')
      //   return false
      // } 
      else if (this.body.projectUuid === '') {
        this.$message.error('请选择所属精选项目')
        return false
      } else if (this.body.picture === '') {
        this.$message.error('请上传封面图')
        return false
      } else if (this.body.pictureList.length <= 0) {
        this.$message.error('请上传轮播图')
        return false
      } 
      // else if (this.body.video === '') {
      //   this.$message.error('请上传视频')
      //   return false
      // }
      else if (this.body.introduction === '') {
        this.$message.error('请输入户型格局')
        return false
      }
      return true
    },
    handleSubmit() {
      this.body.projectUuid = this.selectProject
      if (this.checkForm()) {
        this.pageType === 'add' ? this.network().addHouse() : this.network().updateHouse()
      }
    },
    handleBack(){
      this.$router.go(-1)
    },
    removeViedo(){
      this.body.video = ''
      this.videoUrl = ''
      this.videoFlag = false
      this.videoNum = 0
      this.uploadLoading = false
      this.videoUploadPercent = 0
    }
  },
  components: {
    UpLoadImg,
    WangEditor
  }
}
</script>

<style lang="scss" scoped>
  .title{
    font-size: 20px;
    font-weight: bold;
    margin: 15px 0;
  }
  .row{
    display: flex;
    margin: 50px 0;
    .item{
      width: 33%;
      display: flex;
      .star{
        &::before{
          content: "*";
          color: red;
          margin-right: 5px;
          font-size: 20px;
        }
      }
      div{
        display: flex;
        align-items: center;
        width: 130px;
      }
      .input{
        width: 40%;
      }
      .select{
        width: 40%;
      }
    }
  }
  .img-box{
    .cover-item{
      margin: 30px 0;
    }
    .carousel-item{
      margin: 30px 0;
    }
    .img-title{
      margin: 30px 0;
    }
  }

  .rich-text-box{
    margin-top: 60px;
    .rich-text{
      margin: 30px 0;
      width: 60%;
    }
  }

  .btn-box{
    margin: 120px 0 30px 0;
    display: flex;
    justify-content: center;
    button{
      height: 40px;
      width: 140px;
    }
  }

  .upload-video{
    display: flex;
    position: relative;
    /deep/.el-upload{
      display: flex;
      flex-direction: column;
      align-items: center;
      .el-button {
        display: flex;
        width: 120px;
      }
    }
  }

  .video{
    height: 350px;
    margin: 15px 0;
  }

  .remove-video{
    margin: 0;
    margin: 15px 0;
  }
</style>
